import {
  merchantContextSelectionResponseSchema,
  merchantContextSummarySchema,
} from "@/features/chat/merchantContextSchemas";
import { baseApi } from "@/shared/api/baseApi";

export interface MerchantContextScope {
  conversationId?: string;
  organizationId: string;
}

interface SelectConversationShopInput {
  conversationId: string;
  organizationId: string;
  reason?: string;
  resourceId: string;
}

function merchantContextUrl({ conversationId, organizationId }: MerchantContextScope) {
  const base = `/v1/organizations/${encodeURIComponent(organizationId)}/merchant-context`;
  if (!conversationId) return base;
  return `${base}?${new URLSearchParams({ conversation_id: conversationId }).toString()}`;
}

export const merchantContextApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMerchantContext: builder.query<
      ReturnType<typeof merchantContextSummarySchema.parse>,
      MerchantContextScope
    >({
      providesTags: (_result, _error, input) => [
        {
          id: `${input.organizationId}:${input.conversationId ?? "workspace"}`,
          type: "MerchantContext",
        },
      ],
      query: merchantContextUrl,
      transformResponse: (response) => merchantContextSummarySchema.parse(response),
    }),
    selectConversationShop: builder.mutation<
      ReturnType<typeof merchantContextSelectionResponseSchema.parse>,
      SelectConversationShopInput
    >({
      invalidatesTags: (_result, _error, input) => [
        {
          id: `${input.organizationId}:${input.conversationId}`,
          type: "MerchantContext",
        },
      ],
      query: ({ conversationId, organizationId, reason, resourceId }) => ({
        body: {
          reason: reason ?? "用户在顶部店铺菜单中选择",
          resource_id: resourceId,
          source: "ui",
        },
        method: "PUT",
        url: `/v1/organizations/${encodeURIComponent(organizationId)}/conversations/${encodeURIComponent(conversationId)}/merchant-context/selections`,
      }),
      transformResponse: (response) =>
        merchantContextSelectionResponseSchema.parse(response),
    }),
  }),
});

export const {
  useGetMerchantContextQuery,
  useSelectConversationShopMutation,
} = merchantContextApi;
